'use client';

import { GetPageComponentViewModel } from '@/types/cml-api';
import useUser from '@/utils/use-user';
import ProductsList from './products-list-carousel/products-list';
import Skeleton from './products-list-carousel/skeleton';
import { useFetchPersonalizedProducts } from '../_utils/use-fetch-personalized-products';
import { IsLoadingLazyProps, LocationType } from '../type';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
  locationType: LocationType;
}
const PersonalizedProductList = ({
  data,
  isLazy,
  locationType
}: Props) => {
  const {
    user,
    isLoading
  } = useUser();
  const {
    data: products,
    isLoading: isLoadingPersonalizedProducts
  } = useFetchPersonalizedProducts(locationType);
  if (isLoading || isLoadingPersonalizedProducts) {
    return <div className='homepage-container relative h-[250px] w-full overflow-hidden lg:h-[282px]'>
                <Skeleton isPinkBox={false} />
            </div>;
  }
  if (!user) return null;
  const currentData = data.items?.at(0);

  // IN FIRST VERSION OF THIS COMPONENT, WE WILL USE THE MIX PERSONALIZED PRODUCTS ONLY
  const mixPersonalizedProducts = products?.items?.find(item => item.type === 'mix')?.products ?? [];
  if (!mixPersonalizedProducts.length) return null;
  const personalizedData: GetPageComponentViewModel = {
    ...data,
    items: [{
      ...currentData,
      items: mixPersonalizedProducts.map(product => ({
        product
      }))
    }]
  };
  return <ProductsList data={personalizedData} isLazy={isLazy} isPersonalized data-sentry-element="ProductsList" data-sentry-component="PersonalizedProductList" data-sentry-source-file="personalized-product-list.tsx" />;
};
export default PersonalizedProductList;